export default (function (value) {
  return typeof value === 'function';
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isFunction.js
// module id = mYNI
// module chunks = 0